import { camelizeKeys } from 'humps';
import { post } from '@namespace/helpers';

export const getUserBonusInfo = () =>
  post('/accounting/api/get_user_bonus_info').then((data) =>
    camelizeKeys(data.response)
  );
